import React, { useEffect, useState, useMemo, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Select from "react-select";
import { useTable, useExpanded } from "react-table";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import moment from "moment";
import Swal from "sweetalert2";

const TransactionAccMgt = ({ permissions }) => {
  const [activeTab, setActiveTab] = useState("");
  const [loading, setLoading] = useState(false);
  const [apiData, setApiData] = useState({
    deliveryChallan: [],
    receiptVoucher: [],
    addition: [],
    deduction: [],
    eventTransaction: [],
  });
  const tabOptions = [
    { value: "delivery", label: "Delivery Challan" },
    { value: "receipt", label: "Receipt Voucher" },
    { value: "addition", label: "Addition" },
    { value: "deduction", label: "Deduction" },
    { value: "event", label: "Event Transaction" },
  ];

  const [ledgerOptions, setLedgerOptions] = useState([]);
  const token = localStorage.getItem("token");
  const email = localStorage.getItem("email");
  const role = localStorage.getItem("role");
  const [selectedLedgerRv, setSelectedLedgerRv] = useState({});

  const loginId = localStorage.getItem("sewadarId");

  // ---------------- States for DC
  const [showEnabled, setShowEnabled] = useState({}); // { [rowId]: true }
  const [selectedOnAccount, setSelectedOnAccount] = useState({});
  const [selectedGoods, setSelectedGoods] = useState({});

  // ---------------- States for RV
  const [showEnabledRv, setShowEnabledRv] = useState({});
  const [selectedOnAccountRv, setSelectedOnAccountRv] = useState({});
  const [selectedGoodsRv, setSelectedGoodsRv] = useState({});

  // ---------------- States for ADD
  const [showEnabledAdd, setShowEnabledAdd] = useState({});
  const [selectedTransactionAdd, setSelectedTransactionAdd] = useState({});

  // ---------------- States for LESS
  const [showEnabledLess, setShowEnabledLess] = useState({});
  const [selectedTransactionLess, setSelectedTransactionLess] = useState({});

  // ---------------- States for RV
  const [selectedPurposeRv, setSelectedPurposeRv] = useState({});

  // ---------------- States for EVENT
  const [showEnabledEvent, setShowEnabledEvent] = useState({});
  const [projectCache, setProjectCache] = useState({});

  const [selectedTransactionEvent, setSelectedTransactionEvent] = useState({});

  const [editCache, setEditCache] = useState({});

  const [searchDelivery, setSearchDelivery] = useState("");
  const [searchReceipt, setSearchReceipt] = useState("");
  const [searchAddition, setSearchAddition] = useState("");
  const [searchDeduction, setSearchDeduction] = useState("");
  const [searchEvent, setSearchEvent] = useState("");
  const centerCode = localStorage.getItem("code");
  const [purposeOptions, setPurposeOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [selectedProjectsDc, setSelectedProjectsDc] = useState({});
  const [selectedProjectsRv, setSelectedProjectsRv] = useState({});

  const fetchProjects = async () => {
    try {
      const res = await apiClient.get(`${SERVER_BASE}/area-projects`);
      const options = res.data.map((proj) => ({
        value: proj.id,
        label: `${proj.projectName || ""} ${
          proj.projectCode ? `- [ Code : ${proj.projectCode} ]` : ""
        } ${proj.approvalNo ? `- [ Approval No: ${proj.approvalNo} ]` : ""} ${
          proj.approvalDate
            ? `- [ Date : ${moment(proj.approvalDate).format("DD-MMM-YY")} ]`
            : ""
        }`,
      }));
      setProjectOptions(options);
    } catch (err) {
      console.error("Failed to load projects", err);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  const mapProjectIdsToOptions = (ids) => {
    if (!ids || !projectOptions.length) return [];
    const idArray = ids.split(",").map((id) => Number(id));
    return projectOptions.filter((p) => idArray.includes(p.value));
  };

  const fetchPurposes = async () => {
    try {
      const response = await apiClient.get(
        SERVER_BASE + "/getPurposeByLedgerForTam",
        {
          params: { code: centerCode, type: "rv" },
          headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          },
        }
      );

      const options = response.data.map((purpose) => ({
        value: purpose.id, // Adjust based on API response structure
        label: purpose.purposeName,
        cameFrom: purpose?.ledgerName,
      }));
      setPurposeOptions(options);
    } catch (error) {
      console.error("Error fetching purposes:", error);
    }
  };
  useEffect(() => {
    fetchPurposes();
  }, []);
  const onAccountOptions = [
    { value: "Regular", label: "Regular" },
    { value: "Project", label: "Project" },
    { value: "AHQ", label: "AHQ" },
  ];

  const goodsOptions = [
    { value: "Sending as Transfer", label: "Sending as Transfer" },
    {
      value: "Now, Sending on Returnable Basis",
      label: "Now, Sending on Returnable Basis",
    },
    {
      value: "Earlier Received on Returnable Basis",
      label: "Earlier Received on Returnable Basis",
    },
    {
      value: "Exchange with Condemned Inventory",
      label: "Exchange with Condemned Inventory",
    },
    {
      value: "Exchange with Earlier issued Inventory",
      label: "Exchange with Earlier issued Inventory",
    },
  ];

  const rvGoodsOptions = [
    { value: "Received as Transfer", label: "Received as Transfer" },
    {
      value: "Now, received on Returnable Basis",
      label: "Now, received on Returnable Basis",
    },
    {
      value: "Earlier Sent on Returnable Basis",
      label: "Earlier Sent on Returnable Basis",
    },
    {
      value: "Received as Condemned Inventory",
      label: "Received as Condemned Inventory",
    },
    { value: "Received for Exchange", label: "Received for Exchange" },
    { value: "Purchase", label: "Purchase" },
  ];

  const autoCancelOtherRows = (stateObj, newRowId, type) => {
    const activeRowId = Object.keys(stateObj)?.[0]; // only 1 row is active per tab
    if (!activeRowId) return;

    if (String(activeRowId) != String(newRowId)) {
      // Get the api row
      let row = null;
      if (type == "DC")
        row = apiData.deliveryChallan.find((r) => r.id == activeRowId);
      if (type == "RV")
        row = apiData.receiptVoucher.find((r) => r.id == activeRowId);
      if (type == "ADD")
        row = apiData.addition.find((r) => r.id == activeRowId);
      if (type == "LESS")
        row = apiData.deduction.find((r) => r.id == activeRowId);
      if (type == "EVENT")
        row = apiData.eventTransaction.find((r) => r.id == activeRowId);

      if (row) {
        revertRowChanges(type, row); // revert dropdowns to original
      }

      // Clear edit mode
      if (type == "DC") setShowEnabled({});
      if (type == "RV") setShowEnabledRv({});
      if (type == "ADD") setShowEnabledAdd({});
      if (type == "LESS") setShowEnabledLess({});
      if (type == "EVENT") setShowEnabledEvent({});

      // Clear cache
      const key = cacheKey(type, activeRowId);
      setEditCache((prev) => {
        const cp = { ...prev };
        delete cp[key];
        return cp;
      });
    }
  };

  useEffect(() => {
    const fetchLedgerMasterDetails = async () => {
      try {
        const response = await apiClient.get(SERVER_BASE + "/ledgerMasters", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const options = response.data.map((ledger) => ({
          value: ledger.id,
          label: ledger.printName,
          ledgerId: ledger.id,
          group: ledger.ledgerGroup,
          address: ledger.address,
          gstin: ledger.gstin,
        }));

        setLedgerOptions(options);
      } catch (error) {
        console.error("Error fetching ledger master details:", error);
      }
    };

    fetchLedgerMasterDetails();
  }, [email, role]);

  const fetchData = useCallback(async () => {
    if (!activeTab) return;

    setLoading(true);
    try {
      const res = await apiClient.get(
        `${SERVER_BASE}/getAllTransactionData?voucher=${activeTab}`
      );

      // Set only returned array for that tab
      setApiData((prev) => ({
        ...prev,
        deliveryChallan: res.data.deliveryChallan || prev.deliveryChallan,
        receiptVoucher: res.data.receiptVoucher || prev.receiptVoucher,
        addition: res.data.addition || prev.addition,
        deduction: res.data.deduction || prev.deduction,
        eventTransaction: res.data.eventTransaction || prev.eventTransaction,
      }));
    } catch (error) {
      console.error("API Error:", error);
      Swal.fire("Error", "Failed to load data", "error");
    } finally {
      setLoading(false);
    }
  }, [activeTab]);
  useEffect(() => {
    fetchData();
  }, [activeTab, fetchData]);

  // ---------------- Search helper
  const filterData = (data, searchText) => {
    if (!searchText) return data || [];
    const q = searchText.toString().toLowerCase();
    return (data || []).filter((row) =>
      Object.values(row).some(
        (val) =>
          val != null &&
          val != undefined &&
          String(val).toLowerCase().includes(q)
      )
    );
  };

  // ---------------- Edit cache helpers
  const cacheKey = (type, rowId) => `${type}_${rowId}`;

  const storeOriginalValues = (type, row) => {
    const key = cacheKey(type, row.id);
    // If already cached, don't override (allows user to revert to first original state)
    setEditCache((prev) => {
      if (prev[key]) return prev;
      const snapshot = {};
      if (type == "DC") {
        snapshot.onAccount = row.onAccount ?? null;
        snapshot.received_goods = row.received_goods ?? null;
        snapshot.projects = row.selectedProjects ?? null;
      } else if (type == "RV") {
        snapshot.onAccount = row.onAccount ?? null;
        snapshot.inventory = row.inventory ?? null;
        snapshot.ledgerId = row.ledgerId ?? null;
        snapshot.ledgerName = row.ledgerName ?? null;
        snapshot.purposeId = row.purposeId ?? null; // ✅ ADD
        snapshot.purposeName = row.purposeName ?? null; // ✅ add
        snapshot.projects = row.selectedProjects ?? null;
      } else if (type == "ADD") {
        snapshot.transaction = row.transaction ?? null;
      } else if (type == "LESS") {
        snapshot.transaction = row.transaction ?? null;
      } else if (type == "EVENT") {
        snapshot.transactionType = row.transactionType ?? null;
      }
      return { ...prev, [key]: snapshot };
    });
  };

  const revertRowChanges = (type, row) => {
    const key = cacheKey(type, row.id);
    const cached = editCache[key];

    // If nothing cached, just clear UI selections for safety
    if (!cached) {
      if (type == "DC") {
        setSelectedOnAccount((prev) => ({ ...prev, [row.id]: null }));
        setSelectedGoods((prev) => ({ ...prev, [row.id]: null }));
        setSelectedProjectsDc((prev) => ({
          ...prev,
          [row.id]: mapProjectIdsToOptions(cached.projects),
        }));
      } else if (type == "RV") {
        setSelectedOnAccountRv((prev) => ({ ...prev, [row.id]: null }));
        setSelectedGoodsRv((prev) => ({ ...prev, [row.id]: null }));
        setSelectedLedgerRv((prev) => ({ ...prev, [row.id]: null }));
        setSelectedPurposeRv((prev) => ({ ...prev, [row.id]: null }));
        setSelectedProjectsRv((prev) => ({
          ...prev,
          [row.id]: mapProjectIdsToOptions(cached.projects),
        }));
      } else if (type == "ADD") {
        setSelectedTransactionAdd((prev) => ({ ...prev, [row.id]: null }));
      } else if (type == "LESS") {
        setSelectedTransactionLess((prev) => ({ ...prev, [row.id]: null }));
      } else if (type == "EVENT") {
        setSelectedTransactionEvent((prev) => ({ ...prev, [row.id]: null }));
      }
      // Also remove cache key if exists
      setEditCache((prev) => {
        const cp = { ...prev };
        delete cp[key];
        return cp;
      });
      return;
    }

    // Revert selections to cached original values
    if (type == "DC") {
      setSelectedOnAccount((prev) => ({
        ...prev,
        [row.id]: cached.onAccount
          ? onAccountOptions.find((o) => o.value == cached.onAccount)
          : null,
      }));
      setSelectedGoods((prev) => ({
        ...prev,
        [row.id]: cached.received_goods
          ? goodsOptions.find((o) => o.value == cached.received_goods)
          : null,
      }));
    } else if (type == "RV") {
      setSelectedOnAccountRv((prev) => ({
        ...prev,
        [row.id]: cached.onAccount
          ? onAccountOptions.find((o) => o.value == cached.onAccount)
          : null,
      }));
      setSelectedGoodsRv((prev) => ({
        ...prev,
        [row.id]: cached.inventory
          ? rvGoodsOptions.find((o) => o.value == cached.inventory)
          : null,
      }));
      setSelectedLedgerRv((prev) => ({
        ...prev,
        [row.id]:
          cached.ledgerId && ledgerOptions.length
            ? ledgerOptions.find((l) => l.value == cached.ledgerId) ||
              (cached.ledgerName
                ? { label: cached.ledgerName, value: cached.ledgerId }
                : null)
            : cached.ledgerName
            ? { label: cached.ledgerName, value: cached.ledgerId }
            : null,
      }));
      // ✅ Explicitly restore DB purpose on cancel
      setSelectedPurposeRv((prev) => {
        const cp = { ...prev };

        if (cached.purposeId) {
          cp[row.id] =
            purposeOptions.find((p) => p.value == cached.purposeId) || null;
        } else {
          delete cp[row.id];
        }

        return cp;
      });
    } else if (type == "ADD") {
      setSelectedTransactionAdd((prev) => ({
        ...prev,
        [row.id]: cached.transaction
          ? onAccountOptions.find((o) => o.value == cached.transaction)
          : null,
      }));
    } else if (type == "LESS") {
      setSelectedTransactionLess((prev) => ({
        ...prev,
        [row.id]: cached.transaction
          ? onAccountOptions.find((o) => o.value == cached.transaction)
          : null,
      }));
    } else if (type == "EVENT") {
      setSelectedTransactionEvent((prev) => ({
        ...prev,
        [row.id]: cached.transactionType
          ? onAccountOptions.find((o) => o.value == cached.transactionType)
          : null,
      }));
    }

    // remove the cache for this row
    setEditCache((prev) => {
      const copy = { ...prev };
      delete copy[key];
      return copy;
    });
  };

  // ---------------- Professional handleSave: send received_goods always (frontend-side)
  const handleSave = async (rowId, type, row) => {
    // Build payload: always include received_goods (frontend rule) and onAccount if present
    const payload = {
      type,
      id: rowId,
      loginId,
      email,
      onAccount: null,
      received_goods: null,
    };

    if (type == "DC") {
      payload.onAccount =
        selectedOnAccount[rowId]?.value ?? row.onAccount ?? null;

      payload.received_goods =
        selectedGoods[rowId]?.value ?? row.received_goods ?? null;

      payload.projectIds =
        selectedProjectsDc[rowId]?.map((p) => p.value).join(",") ??
        row.selectedProjects ??
        null;
    }
    if (type == "RV") {
      payload.onAccount =
        selectedOnAccountRv[rowId]?.value ?? row.onAccount ?? null;
      payload.received_goods =
        selectedGoodsRv[rowId]?.value ?? row.inventory ?? null;
      payload.ledger = selectedLedgerRv[rowId]?.label ?? row.ledgerName ?? null;
      payload.ledgerId =
        selectedLedgerRv[rowId]?.ledgerId ??
        selectedLedgerRv[rowId]?.value ??
        row.ledgerId ??
        null;
      payload.purposeId = showEnabledRv[rowId]
        ? selectedPurposeRv[rowId]?.value
        : row.purposeId;
      
      payload.purposeName = showEnabledRv[rowId]
        ? selectedPurposeRv[rowId]?.label ?? null
        : row.purposeName ?? null;
      payload.projectIds =
        selectedProjectsRv[rowId]?.map((p) => p.value).join(",") ??
        row.selectedProjects ??
        null;
    }

    if (type == "ADD") {
      payload.onAccount =
        selectedTransactionAdd[rowId]?.value ?? row.onAccount ?? null;
      // store the transaction value in received_goods (backend will use accordingly)
      payload.received_goods =
        selectedTransactionAdd[rowId]?.value ?? row.transactions ?? null;
    }

    if (type == "LESS") {
      payload.onAccount =
        selectedTransactionLess[rowId]?.value ?? row.onAccount ?? null;
      payload.received_goods =
        selectedTransactionLess[rowId]?.value ?? row.transactions ?? null;
    }

    if (type == "EVENT") {
      payload.onAccount =
        selectedTransactionEvent[rowId]?.value ?? row.onAccount ?? null;
      payload.received_goods =
        selectedTransactionEvent[rowId]?.value ?? row.transactionType ?? null;
    }

    try {
      // setLoading(true);
      const res = await apiClient.post(
        SERVER_BASE + `/updateTransactionFields`,
        payload
      );

      Swal.fire({
        icon: "success",
        title: "Saved",
        text: res?.data?.message,
        timer: 1400,
        showConfirmButton: false,
        toast: true,
        position: "top-end",
        timerProgressBar: true,
      });
      // Clear edit mode for that row and clear cache
      const key = cacheKey(type, rowId);
      setEditCache((prev) => {
        const copy = { ...prev };
        delete copy[key];
        return copy;
      });

      setShowEnabled({});
      setShowEnabledRv({});
      setShowEnabledAdd({});
      setShowEnabledLess({});
      setShowEnabledEvent({});
      fetchData();
    } catch (error) {
      console.error("Save failed:", error);
      Swal.fire({
        icon: "error",
        title: "Save Failed",
        text: "Unable to update the record",
      });
    } finally {
      setLoading(false);
    }
  };

  // ---------------- Table base component (accepts highlightRow function)
  const ReactTableBase = ({
    columns,
    data,
    renderSubComponent,
    highlightRow,
  }) => {
    const tableInstance = useTable({ columns, data }, useExpanded);

    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
      tableInstance;
    return (
      <table
        className="table table-bordered table-striped table-responsive mt-3"
        {...getTableProps()}
        style={{ fontSize: "13px" }}
      >
        <thead>
          {headerGroups.map((hg, idx) => (
            <tr key={idx} {...hg.getHeaderGroupProps()}>
              {hg.headers.map((col, ci) => (
                <th
                  key={ci}
                  {...col.getHeaderProps({
                    style: {
                      width: col.width,
                      minWidth: col.minWidth,
                      maxWidth: col.maxWidth,
                    },
                  })}
                >
                  {col.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            const style = highlightRow ? highlightRow(row) : {};
            return (
              <React.Fragment key={row.id}>
                <tr {...row.getRowProps()} style={style}>
                  {row.cells.map((cell, cidx) => (
                    <td key={cidx} {...cell.getCellProps()}>
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>

                {row.isExpanded && renderSubComponent && (
                  <tr>
                    <td colSpan={row.cells.length}>
                      {renderSubComponent({ row })}
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    );
  };
  const compactSelectStyles = {
    container: (base) => ({
      ...base,
      width: "100%",
      minWidth: 0,
    }),
    control: (base) => ({
      ...base,
      minHeight: "32px",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 6px",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      padding: "0 4px",
    }),
  };

  // ---------------- Delivery columns
  const deliveryColumns = useMemo(
    () => [
      {
        Header: "Date",
        width: "10%", // 👈 SET COLUMN WIDTH
        minWidth: 25,
        maxWidth: 50,

        accessor: (row) =>
          row.date ? moment(row.date).format("DD-MMM-YY") : "",
        Cell: ({ value }) => (
          <div
          // style={{
          //   width: "60px",
          // }}
          >
            {value}
          </div>
        ),
      },
      {
        Header: "Challan No",
        accessor: (row) => `${row.prefix || ""}${row.refNo || ""}`,
        Cell: ({ value }) => (
          <div
            style={{
              width: "100px",
            }}
          >
            {value}
          </div>
        ),
      },
      {
        Header: "Ledger",
        accessor: "ledger",
        Cell: ({ value }) => (
          <div
            style={{
              maxWidth: "280px",
              // whiteSpace: "nowrap",
              // overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {value}
          </div>
        ),
      },
      {
        Header: "On Account",
        id: "onAccount",
        Cell: ({ row }) => {
          const r = row.original;
          const rowId = r.id;
          const isEnabled = showEnabled[rowId] ?? false;

          return (
            <Select
              options={onAccountOptions}
              isDisabled={!isEnabled}
              value={
                selectedOnAccount[rowId] ??
                onAccountOptions.find((o) => o.value == r.onAccount) ??
                null
              }
              onChange={(val) =>
                setSelectedOnAccount((prev) => ({ ...prev, [rowId]: val }))
              }
            />
          );
        },
      },
      {
        Header: "Inventory",
        width: "15%",
        minWidth: 200,
        maxWidth: 400,
        id: "received_goods",
        Cell: ({ row }) => {
          const r = row.original;
          const rowId = r.id;
          const isEnabled = showEnabled[rowId] ?? false;

          return (
            <Select
              options={goodsOptions}
              isDisabled={!isEnabled}
              value={
                selectedGoods[rowId] ??
                goodsOptions.find((o) => o.value == r.received_goods) ??
                null
              }
              onChange={(val) =>
                setSelectedGoods((prev) => ({ ...prev, [rowId]: val }))
              }
            />
          );
        },
      },
      {
        Header: "Project",
        id: "project_dc",
        width: 80, // 👈 SET COLUMN WIDTH
        minWidth: 80,
        maxWidth: 80,
        Cell: ({ row }) => {
          const r = row.original;
          const rowId = r.id;
          const isEnabled = showEnabled[rowId] ?? false;
          const hasEdited = Object.prototype.hasOwnProperty.call(
            selectedProjectsDc,
            rowId
          );
          return (
            <Select
              styles={compactSelectStyles}
              options={projectOptions}
              isMulti
              isDisabled={!isEnabled}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              value={
                hasEdited
                  ? selectedProjectsDc[rowId]
                  : mapProjectIdsToOptions(r.selectedProjects)
              }
              onChange={(val) =>
                setSelectedProjectsDc((prev) => ({
                  ...prev,
                  [rowId]: val,
                }))
              }
            />
          );
        },
      },

      {
        Header: "Action",
        id: "actions",
        Cell: ({ row }) => {
          const r = row.original;
          const rowId = r.id;
          const isEnabled = showEnabled[rowId] ?? false;

          return (
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                className={
                  isEnabled ? "btn btn-danger btn-sm" : "btn btn-primary btn-sm"
                }
                onClick={async () => {
                  if (!isEnabled) {
                    autoCancelOtherRows(showEnabled, rowId, "DC");
                    storeOriginalValues("DC", r);

                    // 🔥 IMPORTANT: initialize editable project state
                    setSelectedProjectsDc((prev) => ({
                      ...prev,
                      [rowId]: mapProjectIdsToOptions(r.selectedProjects),
                    }));

                    setShowEnabled({ [rowId]: true });
                  } else {
                    revertRowChanges("DC", r);
                    setShowEnabled({});
                  }
                }}
              >
                {isEnabled ? "Cancel" : "Edit"}
              </button>

              <button
                className={`${
                  isEnabled
                    ? "btn-success btn btn-sm"
                    : "btn-primary btn btn-sm"
                }`}
                disabled={!isEnabled}
                onClick={() => handleSave(rowId, "DC", r)}
              >
                Save
              </button>
            </div>
          );
        },
      },
    ],
    [
      showEnabled,
      selectedOnAccount,
      selectedGoods,
      editCache,
      ledgerOptions,
      selectedProjectsDc, // 🔥 REQUIRED
      projectOptions, // 🔥 REQUIRED
    ]
  );

  const renderDeliveryItems = ({ row }) => (
    <table className="table table-sm table-bordered mt-2">
      <thead className="table-secondary">
        <tr>
          <th>Item Name</th>
          <th>Quantity</th>
          <th>UOM</th>
          <th>Remarks</th>
        </tr>
      </thead>
      <tbody>
        {row.original.items?.map((it, i) => (
          <tr key={i}>
            <td>{it.itemName}</td>
            <td>{it.quantity}</td>
            <td>{it.uom}</td>
            <td>{it.remarks}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  // ---------------- Receipt columns
  const receiptColumns = useMemo(
    () => [
      {
        Header: "Date",
        width: "8%",
        minWidth: 120,
        maxWidth: 200,
        accessor: (row) =>
          row.srDate
            ? moment(row.srDate).format("DD-MMM-YY")
            : row.documentDate
            ? moment(row.documentDate).format("DD-MMM-YY")
            : "",
      },
      {
        Header: "RV No",
        width: "8%",
        minWidth: 120,
        maxWidth: 200,
        accessor: "rvNo",
      },
      {
        Header: "Ledger",
        id: "ledgerSelect",
        width: "30%",
        minWidth: 200,
        maxWidth: 350,

        Cell: ({ row }) => {
          const r = row.original;
          const rowId = r.id;
          const isEnabled = showEnabledRv[rowId] ?? false;

          return (
            <Select
              options={ledgerOptions}
              isDisabled={!isEnabled}
              value={
                selectedLedgerRv[rowId] ??
                ledgerOptions.find((l) => l.value == r.ledgerId) ??
                null
              }
              onChange={(val) =>
                setSelectedLedgerRv((prev) => ({ ...prev, [rowId]: val }))
              }
            />
          );
        },
      },

      {
        Header: "On Account",
        width: "8%",
        minWidth: 120,
        maxWidth: 200,
        id: "onAccountRv",
        Cell: ({ row }) => {
          const r = row.original;
          const rowId = r.id;
          const isEnabled = showEnabledRv[rowId] ?? false;
          return (
            <Select
              options={onAccountOptions}
              isDisabled={!isEnabled}
              value={
                selectedOnAccountRv[rowId] ??
                onAccountOptions.find((o) => o.value == r.onAccount) ??
                null
              }
              onChange={(val) =>
                setSelectedOnAccountRv((prev) => ({ ...prev, [rowId]: val }))
              }
            />
          );
        },
      },
      {
        Header: "Inventory",
        width: "8%",
        minWidth: 120,
        maxWidth: 200,
        id: "inventory_rv",
        Cell: ({ row }) => {
          const r = row.original;
          const rowId = r.id;
          const isEnabled = showEnabledRv[rowId] ?? false;
          return (
            <Select
              options={rvGoodsOptions}
              isDisabled={!isEnabled}
              value={
                selectedGoodsRv[rowId] ??
                rvGoodsOptions.find((o) => o.value == r.inventory) ??
                null
              }
              onChange={(val) =>
                setSelectedGoodsRv((prev) => ({ ...prev, [rowId]: val }))
              }
            />
          );
        },
      },
      {
        Header: "Purpose",
        width: "8%",
        minWidth: 120,
        maxWidth: 200,
        id: "purpose_rv",
        Cell: ({ row }) => {
          const r = row.original;
          const rowId = r.id;
          const isEnabled = showEnabledRv[rowId] ?? false;

          const dbOption =
            purposeOptions.find((p) => p.value == r.purposeId) || null;

          const filteredOptions = purposeOptions.filter(
            (p) => p.cameFrom == r.cameFrom
          );

          const optionsToShow = dbOption
            ? [
                dbOption,
                ...filteredOptions.filter((p) => p.value != dbOption.value),
              ]
            : filteredOptions;

          const hasEdited = Object.prototype.hasOwnProperty.call(
            selectedPurposeRv,
            rowId
          );

          return (
            <Select
              styles={compactSelectStyles}
              options={optionsToShow}
              isDisabled={!isEnabled}
              value={hasEdited ? selectedPurposeRv[rowId] : dbOption}
              onChange={(val) => {
                if (!isEnabled) return;
                setSelectedPurposeRv((prev) => ({
                  ...prev,
                  [rowId]: val,
                }));
              }}
            />
          );
        },
      },
      {
        Header: "Project",
        id: "project_rv",
        width: "8%",
        minWidth: 120,
        maxWidth: 200,
        Cell: ({ row }) => {
          const r = row.original;
          const rowId = r.id;
          const isEnabled = showEnabledRv[rowId] ?? false;
          const hasEdited = Object.prototype.hasOwnProperty.call(
            selectedProjectsRv,
            rowId
          );
          return (
            <Select
              styles={compactSelectStyles}
              options={projectOptions}
              isMulti
              isDisabled={!isEnabled}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              value={
                hasEdited
                  ? selectedProjectsRv[rowId]
                  : mapProjectIdsToOptions(r.selectedProjects)
              }
              onChange={(val) =>
                setSelectedProjectsRv((prev) => ({
                  ...prev,
                  [rowId]: val,
                }))
              }
            />
          );
        },
      },

      {
        Header: "Action",
        id: "actionsRv",
        Cell: ({ row }) => {
          const r = row.original;
          const rowId = r.id;
          const isEnabled = showEnabledRv[rowId] ?? false;
          return (
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                className={`${
                  isEnabled ? "btn-danger btn btn-sm" : "btn-primary btn btn-sm"
                }`}
                onClick={() => {
                  if (!isEnabled) {
                    autoCancelOtherRows(
                      showEnabledRv,
                      rowId,
                      "RV",
                      showEnabledRv
                    );

                    storeOriginalValues("RV", r);

                    setShowEnabledRv({ [rowId]: true });
                  } else {
                    revertRowChanges("RV", r);
                    setShowEnabledRv({});
                  }
                }}
              >
                {isEnabled ? "Cancel" : "Edit"}
              </button>
              <button
                className={`${
                  isEnabled
                    ? "btn-success btn btn-sm"
                    : "btn-primary btn btn-sm"
                }`}
                disabled={!isEnabled}
                onClick={() => handleSave(rowId, "RV", r)}
              >
                Save
              </button>
            </div>
          );
        },
      },
    ],
    [
      showEnabledRv,
      selectedOnAccountRv,
      selectedGoodsRv,
      selectedLedgerRv,
      ledgerOptions,
      editCache,
      selectedPurposeRv,
      purposeOptions,
      selectedProjectsRv,
      projectOptions,
    ]
  );

  const renderReceiptItems = ({ row }) => (
    <table className="table table-sm table-bordered mt-2">
      <thead className="table-secondary">
        <tr>
          <th>Item</th>
          <th>Qty</th>
          <th>UOM</th>
        </tr>
      </thead>
      <tbody>
        {row.original.items?.map((it, i) => (
          <tr key={i}>
            <td>{it.itemName}</td>
            <td>{it.receivedQty}</td>
            <td>{it.uom}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  // ---------------- Addition columns
  const additionColumns = useMemo(
    () => [
      {
        Header: "Date",
        accessor: (row) =>
          row.date ? moment(row.date).format("DD-MMM-YY") : "",
      },
      { Header: "Ref No.", accessor: "draftCode" },
      { Header: "Event", accessor: "purpose" },
      {
        Header: "Transaction",
        id: "transaction_add",
        Cell: ({ row }) => {
          const r = row.original;
          const rowId = r.id;
          const isEnabled = showEnabledAdd[rowId] ?? false;
          return (
            <Select
              options={onAccountOptions}
              isDisabled={!isEnabled}
              value={
                selectedTransactionAdd[rowId] ??
                onAccountOptions.find((o) => o.value == r.transaction) ??
                null
              }
              onChange={(val) =>
                setSelectedTransactionAdd((prev) => ({ ...prev, [rowId]: val }))
              }
            />
          );
        },
      },
      {
        Header: "Action",
        id: "actions_add",
        Cell: ({ row }) => {
          const r = row.original;
          const rowId = r.id;
          const isEnabled = showEnabledAdd[rowId] ?? false;
          return (
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                className={`${
                  isEnabled ? "btn-danger btn btn-sm" : "btn-primary btn btn-sm"
                }`}
                onClick={() => {
                  if (!isEnabled) {
                    autoCancelOtherRows(showEnabledAdd, rowId, "ADD");
                    storeOriginalValues("ADD", r);
                    setShowEnabledAdd({ [rowId]: true });
                  } else {
                    revertRowChanges("ADD", r);
                    setShowEnabledAdd({});
                  }
                }}
              >
                {isEnabled ? "Cancel" : "Edit"}
              </button>

              <button
                className={`${
                  isEnabled
                    ? "btn-success btn btn-sm"
                    : "btn-primary btn btn-sm"
                }`}
                disabled={!isEnabled}
                onClick={() => handleSave(rowId, "ADD", r)}
              >
                Save
              </button>
            </div>
          );
        },
      },
    ],
    [showEnabledAdd, selectedTransactionAdd, editCache]
  );

  const deductionColumns = useMemo(
    () => [
      {
        Header: "Date",
        accessor: (row) =>
          row.date ? moment(row.date).format("DD-MMM-YY") : "",
      },
      { Header: "Ref No.", accessor: "draftCode" },
      { Header: "Event", accessor: "purpose" },
      {
        Header: "Transaction",
        id: "transaction_less",
        Cell: ({ row }) => {
          const r = row.original;
          const rowId = r.id;
          const isEnabled = showEnabledLess[rowId] ?? false;
          return (
            <Select
              options={onAccountOptions}
              isDisabled={!isEnabled}
              value={
                selectedTransactionLess[rowId] ??
                onAccountOptions.find((o) => o.value == r.transaction) ??
                null
              }
              onChange={(val) =>
                setSelectedTransactionLess((prev) => ({
                  ...prev,
                  [rowId]: val,
                }))
              }
            />
          );
        },
      },
      {
        Header: "Action",
        id: "actions_less",
        Cell: ({ row }) => {
          const r = row.original;
          const rowId = r.id;
          const isEnabled = showEnabledLess[rowId] ?? false;
          return (
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                className={`${
                  isEnabled ? "btn-danger btn btn-sm" : "btn-primary btn btn-sm"
                }`}
                onClick={() => {
                  if (!isEnabled) {
                    autoCancelOtherRows(showEnabledLess, rowId, "LESS");
                    storeOriginalValues("LESS", r);
                    setShowEnabledLess({ [rowId]: true });
                  } else {
                    revertRowChanges("LESS", r);
                    setShowEnabledLess({});
                  }
                }}
              >
                {isEnabled ? "Cancel" : "Edit"}
              </button>
              <button
                className={`${
                  isEnabled
                    ? "btn-success btn btn-sm"
                    : "btn-primary btn btn-sm"
                }`}
                disabled={!isEnabled}
                onClick={() => handleSave(rowId, "LESS", r)}
              >
                Save
              </button>
            </div>
          );
        },
      },
    ],
    [showEnabledLess, selectedTransactionLess, editCache]
  );

  // ---------------- Event columns
  const eventColumns = useMemo(
    () => [
      {
        Header: "Date",
        accessor: (row) =>
          row.date ? moment(row.date).format("DD-MMM-YY") : "",
      },
      { Header: "Ref No", accessor: "transactionCode" },
      { Header: "Event", accessor: "event" },
      {
        Header: "Transaction",
        id: "transaction_event",
        Cell: ({ row }) => {
          const r = row.original;
          const rowId = r.id;
          const isEnabled = showEnabledEvent[rowId] ?? false;
          return (
            <Select
              options={onAccountOptions}
              isDisabled={!isEnabled}
              value={
                selectedTransactionEvent[rowId] ??
                onAccountOptions.find((o) => o.value == r.transactionType) ??
                null
              }
              onChange={(val) =>
                setSelectedTransactionEvent((prev) => ({
                  ...prev,
                  [rowId]: val,
                }))
              }
            />
          );
        },
      },
      {
        Header: "Action",
        id: "actions_event",
        Cell: ({ row }) => {
          const r = row.original;
          const rowId = r.id;
          const isEnabled = showEnabledEvent[rowId] ?? false;
          return (
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                className={`${
                  isEnabled ? "btn-danger btn btn-sm" : "btn-primary btn btn-sm"
                }`}
                onClick={() => {
                  if (!isEnabled) {
                    autoCancelOtherRows(showEnabledEvent, rowId, "EVENT");
                    storeOriginalValues("EVENT", r);
                    setShowEnabledEvent({ [rowId]: true });
                  } else {
                    revertRowChanges("EVENT", r);
                    setShowEnabledEvent({});
                  }
                }}
              >
                {isEnabled ? "Cancel" : "Edit"}
              </button>
              <button
                className={`${
                  isEnabled
                    ? "btn-success btn btn-sm"
                    : "btn-primary btn btn-sm"
                }`}
                disabled={!isEnabled}
                onClick={() => handleSave(rowId, "EVENT", r)}
              >
                Save
              </button>
            </div>
          );
        },
      },
    ],
    [showEnabledEvent, selectedTransactionEvent, editCache]
  );

  return (
    <div className="formcontainer mt-5">
      <div className="row">
        <div className="col-md-9">
          <h5 className="mb-2">Voucher Inventory Management</h5>
        </div>
        <div className="col-md-3">
          <Select
            className=""
            options={tabOptions}
            isClearable
            value={tabOptions.find((t) => t.value == activeTab) || null}
            onChange={(sel) => setActiveTab(sel ? sel.value : "")}
          />
        </div>
      </div>

      <div className="mt-3">
        {loading && <p>Loading...</p>}

        {activeTab == "delivery" && !loading && (
          <>
            <input
              type="text"
              placeholder="Search Delivery Challan..."
              className="form-control mb-2"
              value={searchDelivery}
              onChange={(e) => setSearchDelivery(e.target.value)}
            />

            <ReactTableBase
              columns={deliveryColumns}
              data={filterData(apiData.deliveryChallan, searchDelivery)}
              renderSubComponent={renderDeliveryItems}
              highlightRow={(row) =>
                showEnabled[row.original.id]
                  ? { backgroundColor: "#fff7d6" } // subtle yellow
                  : {}
              }
            />
          </>
        )}

        {activeTab == "receipt" && !loading && (
          <>
            <input
              type="text"
              placeholder="Search Receipt Voucher..."
              className="form-control mb-2"
              value={searchReceipt}
              onChange={(e) => setSearchReceipt(e.target.value)}
            />

            <ReactTableBase
              columns={receiptColumns}
              data={filterData(apiData.receiptVoucher, searchReceipt)}
              renderSubComponent={renderReceiptItems}
              highlightRow={(row) =>
                showEnabledRv[row.original.id]
                  ? { backgroundColor: "#fff7d6" }
                  : {}
              }
            />
          </>
        )}

        {activeTab == "addition" && !loading && (
          <>
            <input
              type="text"
              placeholder="Search Addition..."
              className="form-control mb-2"
              value={searchAddition}
              onChange={(e) => setSearchAddition(e.target.value)}
            />

            <ReactTableBase
              columns={additionColumns}
              data={filterData(apiData.addition, searchAddition)}
              highlightRow={(row) =>
                showEnabledAdd[row.original.id]
                  ? { backgroundColor: "#fff7d6" }
                  : {}
              }
            />
          </>
        )}

        {activeTab == "deduction" && !loading && (
          <>
            <input
              type="text"
              placeholder="Search Deduction..."
              className="form-control mb-2"
              value={searchDeduction}
              onChange={(e) => setSearchDeduction(e.target.value)}
            />

            <ReactTableBase
              columns={deductionColumns}
              data={filterData(apiData.deduction, searchDeduction)}
              highlightRow={(row) =>
                showEnabledLess[row.original.id]
                  ? { backgroundColor: "#fff7d6" }
                  : {}
              }
            />
          </>
        )}

        {activeTab == "event" && !loading && (
          <>
            <input
              type="text"
              placeholder="Search Event Transaction..."
              className="form-control mb-2"
              value={searchEvent}
              onChange={(e) => setSearchEvent(e.target.value)}
            />

            <ReactTableBase
              columns={eventColumns}
              data={filterData(apiData.eventTransaction, searchEvent)}
              highlightRow={(row) =>
                showEnabledEvent[row.original.id]
                  ? { backgroundColor: "#fff7d6" }
                  : {}
              }
            />
          </>
        )}
      </div>
    </div>
  );
};

export default TransactionAccMgt;
